import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Button, Table, Tag } from 'antd'

const STATE_KEYS = [
  'requestingQuotation',
  'waitingForSupplier',
  'waitingCustomerConfirm',
  'payment',
  'complete',
  'cancel'
]

const DANGER_COLOR = '#cf1322'

const isOverCapacity = (row) => !!row.assignee && row.remaining <= 0

const Board = ({ loading, onOpenAssignee, rows }) => {
  const { i18n } = useTranslation('leadDistributions')

  const renderAssignee = (row) => {
    if (!row.assignee) {
      return <strong>{i18n.t('leadDistributions:unassigned', { total: row.totalCount })}</strong>
    }

    return (
      <div>
        <div>
          <strong>{row.assignee.fullName}</strong>
          {row.isDistributeSale && (
            <Tag color="blue" style={{ marginLeft: 8 }}>{i18n.t('leadDistributions:distributeSale')}</Tag>
          )}
        </div>
        <div>
          {i18n.t('leadDistributions:capacity.summary', {
            capacity: row.leadAmountPerDay,
            open: row.openCount,
            remaining: row.remaining
          })}
        </div>
      </div>
    )
  }

  const columns = [
    {
      key: 'assignee',
      title: i18n.t('leadDistributions:columns.assignee'),
      render: renderAssignee
    },
    ...STATE_KEYS.map(stateKey => ({
      key: stateKey,
      align: 'right',
      dataIndex: ['stateCounts', stateKey],
      title: i18n.t(`leadDistributions:states.${stateKey}`)
    })),
    {
      key: 'totalCount',
      align: 'right',
      dataIndex: 'totalCount',
      title: i18n.t('leadDistributions:columns.total')
    },
    {
      key: 'actions',
      align: 'right',
      render: (row) => (
        <Button onClick={() => onOpenAssignee(row)} size="small" type="link">
          {i18n.t('leadDistributions:view')}
        </Button>
      )
    }
  ]

  return (
    <Table
      columns={columns}
      dataSource={rows}
      loading={loading}
      locale={{ emptyText: i18n.t('leadDistributions:empty') }}
      onRow={row => (isOverCapacity(row) ? { style: { color: DANGER_COLOR } } : {})}
      pagination={false}
      rowKey={row => (row.assignee ? row.assignee.id : 'unassigned')}
      scroll={{ x: true }}
    />
  )
}

Board.propTypes = {
  loading: PropTypes.bool,
  onOpenAssignee: PropTypes.func.isRequired,
  rows: PropTypes.array.isRequired
}

Board.defaultProps = {
  loading: false
}

export default Board
